// extracted by mini-css-extract-plugin
export var addToCartButton = "_ow-b";
export var arrowButtonContainer = "_ow-9";
export var arrowButtonIcon = "_ow-a";
export var carouselArrowButton = "_ow-6";
export var carouselElementContainer = "_ow-1";
export var left = "_ow-7";
export var productDisplayCarouselContainer = "_ow-0";
export var productTileContainer = "_ow-2";
export var productTileImage = "_ow-4";
export var productTileImageContainer = "_ow-3";
export var productTileTitle = "_ow-5";
export var right = "_ow-8";
export var sliderOverflow = "_ow-c";